type Key = string;
type Value = object | string | boolean;

const hasStorage = (): boolean => typeof localStorage !== 'undefined';

class LocalStorageRepository {
  setItem(key: Key, value: Value): {
    key: Key,
    value: Value,
  } | boolean {
    if (key && hasStorage()) {
      localStorage.setItem(key, JSON.stringify(value));

      return {
        key,
        value: this.getItem(key) ?? value,
      };
    }
    return false;
  }

  getItem<T extends Value>(key: Key): Value | T | null {
    if (!hasStorage()) {
      return null;
    }

    if (key) {
      try {
        // @ts-ignore TODO: FIN-32798 strictNullChecks
        return JSON.parse(localStorage.getItem(key));
      } catch (e) {
        if (localStorage[key]) {
          return localStorage.getItem(key);
        }

        return null;
      }
    }
    return false;
  }

  removeItem(key: Key): boolean {
    if (key && hasStorage()) {
      localStorage.removeItem(key);
      return !this.getItem(key);
    }
    return false;
  }

  clear() {
    if (hasStorage()) {
      localStorage.clear();
    }
  }
}

export default LocalStorageRepository;
